import { Divider, Frow, Subheading1 } from '@pinpointhq/thumbtack';
import * as React from 'react';

interface ISubheadedSectionProps {
  children: React.ReactNode;
  mutedDivider?: boolean;
  showDivider?: boolean;
  title?: string | JSX.Element;
  button?: JSX.Element;
}

export function SubheadedSection({
  children,
  title,
  mutedDivider = false,
  showDivider = true,
  button,
  ...props
}: ISubheadedSectionProps) {
  return (
    <div {...props}>
      {showDivider && <Divider className="mar-v-5" muted={mutedDivider} />}
      {(title || button) && (
        <Frow className="mar-b-2" justifyContent="space-between" alignItems="center" verticalGutters={8}>
          {title && <Subheading1>{title}</Subheading1>}
          {button}
        </Frow>
      )}
      {children}
    </div>
  );
}
